/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_RestoreInputs */

const en_us2_offline_kind_plan_restore = /** @type {(inputs: Offline_Kind_Plan_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo in the plan`)
};

const pt_br2_offline_kind_plan_restore = /** @type {(inputs: Offline_Kind_Plan_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfazer no plano`)
};

const es_419_offline_kind_plan_restore = /** @type {(inputs: Offline_Kind_Plan_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer en el plan`)
};

const pt_pt2_offline_kind_plan_restore = /** @type {(inputs: Offline_Kind_Plan_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anular no plano`)
};

const fr_fr2_offline_kind_plan_restore = /** @type {(inputs: Offline_Kind_Plan_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulation dans le programme`)
};

const de_de2_offline_kind_plan_restore = /** @type {(inputs: Offline_Kind_Plan_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückgängig im Plan`)
};

const it_it2_offline_kind_plan_restore = /** @type {(inputs: Offline_Kind_Plan_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annullamento nella scheda`)
};

/**
* | output |
* | --- |
* | "Undo in the plan" |
*
* @param {Offline_Kind_Plan_RestoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_restore = /** @type {((inputs?: Offline_Kind_Plan_RestoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_RestoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_restore(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_restore(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_restore(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_restore(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_restore(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_restore(inputs)
	return en_us2_offline_kind_plan_restore(inputs)
});
export { offline_kind_plan_restore as "offline.kind_plan_restore" }